import i18next from "i18next";
import signatureEmail from "../../../assets/jpg/email_signature.jpg";
import {
  ICollaborateur,
  Participation
} from "../../../schemas/collaborateur/collaborateur.schema";
import { Etablissement } from "../../../schemas/etablissement/etablissemen.schema";
import { formatDate, formatPhoneWithoutPrefix } from "../../../utils";

const dateLimitInscription = process.env.REACT_APP_DATE_LIMIT_INSCRIPTION;
const websiteUrl = process.env.REACT_APP_WEBSITE_URL;

export function generateInscriptionEmail_Collaborateur(infos: {
  collaborateurInfo: ICollaborateur;
  etablissementInfo: Etablissement;
  participation: Participation;
}) {
  const { etablissementInfo, collaborateurInfo, participation } = infos;
  const t = i18next.t;

  return `<article>
      <p>
        ${t("emails.content.collaborateur.greeting")} ${collaborateurInfo.prenom} ${collaborateurInfo.nom},
      </p
      <p>
        ${t("emails.content.collaborateur.registration.thanks")}
      </p>

      <p>${t("emails.content.collaborateur.registration.dayInfo")}</p>
      <ul>
        <li>${t("emails.content.collaborateur.registration.at")} ${etablissementInfo.name}</li>
        <li>${t("emails.content.collaborateur.registration.address")} ${etablissementInfo?.localisation?.address}</li>
        <li>
          ${t("emails.content.collaborateur.registration.date")} ${formatDate(participation?.dateParticipation, {
    hasDayName: true,
    hasYear: true,
  })}
        </li>
      </ul>

      <p>${t("emails.content.collaborateur.registration.referentContacts")}</p>

      <p>${t("emails.content.collaborateur.registration.referentName")} ${etablissementInfo?.information_referent?.nom_referent || t("emails.content.collaborateur.registration.notProvided")
    }</p>
      <p>${t("emails.content.collaborateur.registration.referentFirstName")} ${etablissementInfo?.information_referent?.prenom_referent ||
    t("emails.content.collaborateur.registration.notProvided")
    }</p>
      <p>${t("emails.content.newRegistration.email")} ${etablissementInfo?.information_referent?.email_referent ||
    t("emails.content.collaborateur.registration.notProvided")
    }</p>
      <p>${t("emails.content.newRegistration.phone")} +49 ${formatPhoneWithoutPrefix(etablissementInfo?.information_referent?.phone_referent) ||
    t("emails.content.collaborateur.registration.notProvided")
    }</p>

    <p>${t("emails.content.collaborateur.registration.cancelInfo")}. ${t("emails.content.collaborateur.registration.afterDeadline")}</p>

    <p>${t("emails.content.regards")}</p>

    <p>${t("emails.content.team")}</p>
    <img
    src="${signatureEmail}"
    alt="signature_logo"
    width={100}
    height={100}
  ></img>
</article > `;
}

export function generateAnnulationEmail_Collaborateur(infos: {
  collaborateurInfo: ICollaborateur;
}) {
  const { collaborateurInfo } = infos;
  const t = i18next.t;

  return `<article>
      <p>
        ${t("emails.content.collaborateur.greeting")} ${collaborateurInfo.prenom} ${collaborateurInfo.nom},
      </p>

      <p>
        ${t("emails.content.collaborateur.cancellation.message")}
      </p>
      <p>${t("emails.content.regards")}</p>

      <p>${t("emails.content.team")}</p>
      <img
      src="${signatureEmail}"
      alt="signature_logo"
      width={100}
      height={100}
    ></img>
  </article > `;
}

export function generateModification_FullUpdate_Collaborateur(infos: {
  collaborateurInfo: ICollaborateur;
  participation: Participation;
  etablissementInfo: Etablissement;
}) {
  const { collaborateurInfo, participation, etablissementInfo } = infos;
  const t = i18next.t;

  return (
    `<article>
      <p>${t("emails.content.collaborateur.greeting")} ${collaborateurInfo.prenom} ${collaborateurInfo.nom},</p>

      <p>
        ${t("emails.content.collaborateur.modification.message")}
      </p>

      <p>${t("emails.content.collaborateur.registration.dayInfo")}</p>
      <ul>

        <li>${t("emails.content.collaborateur.registration.at")} ${etablissementInfo.name}</li>

        <li>${t("emails.content.collaborateur.registration.address")} ${etablissementInfo?.localisation?.address}</li>

        <li>${t("emails.content.collaborateur.registration.date")} ${formatDate(participation.dateParticipation, { hasDayName: true, hasYear: true })}</li>
      </ul>

      <p>
        ${t("emails.content.collaborateur.registration.contact")} ${etablissementInfo.information_DE.prenom_de} ${etablissementInfo.information_DE.nom_de},
        ${t("emails.content.collaborateur.registration.contactReachable")} ${etablissementInfo.information_DE.phone_de} ${t("emails.content.collaborateur.registration.contactOrEmail")} ${etablissementInfo.information_DE.email_de}
      </p>

      <p>${t("emails.content.collaborateur.registration.referentContacts")}</p>

      <p>${t("emails.content.collaborateur.registration.referentName")} ${etablissementInfo?.information_referent?.nom_referent || t("emails.content.collaborateur.registration.notProvided")}</p>
      <p>${t("emails.content.collaborateur.registration.referentFirstName")} ${etablissementInfo?.information_referent?.prenom_referent || t("emails.content.collaborateur.registration.notProvided")}</p>
      <p>${t("emails.content.newRegistration.email")} ${etablissementInfo?.information_referent?.email_referent || t("emails.content.collaborateur.registration.notProvided")}</p>
      <p>${t("emails.content.newRegistration.phone")} +49 ${formatPhoneWithoutPrefix(etablissementInfo?.information_referent?.phone_referent) || t("emails.content.collaborateur.registration.notProvided")}</p>

      <p>
        ${t("emails.content.collaborateur.registration.cancelInfo")}.
        ${t("emails.content.collaborateur.registration.afterDeadline")}
      </p>

      <p>${t("emails.content.regards")}</p>

      <p>${t("emails.content.team")}</p>
      <img
        src="${signatureEmail}"
        alt="signature_logo"
        width={100}
        height={100}
      ></img>
      </article > `
  );
}
